module.exports = __webpack_public_path__ + "img/cnd_Circuit.844af728.svg";